module.exports = {
      id: "ios-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#ios-block",
      toString: function () {
        return this.url;
      }
    }